import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DatePicker, InputNumber, Form, Input, Select } from 'antd';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import locale from 'antd/es/date-picker/locale/ru_RU';
import { GETWITH, QueryOrder, QueryParam, READWITH, errorCatch } from 'fennec-ui';

dayjs.locale('ru');
const { Option } = Select;


export default function NovoeZasedanieRegionalnogoPravleniya(props) {
    const { auth, form, object } = props;
    const [city, setCity] = useState([]);

    useEffect(() => {
        if (object) {
            form.resetFields();
            READWITH(auth, "City", [
                QueryParam("w-region.ID", object?.regionID),
                QueryOrder("name", "ASC")
            ], ({ data }) => {
                setCity(data);
            }, errorCatch)
        }
    }, [object]);

    const options = city.map(i =>
    (
        <Option key={i.ID} value={i.ID}>{i.name}</Option>
    ));

    return (
        <div>
            {props?.subheader}
            <Form
                form={props.form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    neobkhodimiiKvorum: 50,
                    dataZasedaniya: dayjs()
                }}
            >
                <Form.Item
                    name={"nomerProtokolaZasedaniya"}
                    label={"Номер протокола заседания"}
                    rules={[{ required: true, message: 'Укажите номер протокола заседания!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={"dataZasedaniya"}
                    label={"Дата заседания"}
                    rules={[{ required: true, message: 'Укажите дату заседания!' }]}
                >
                    <DatePicker locale={locale} />
                </Form.Item>
                {/* <Form.Item
                name={"regionalnoeOtdelenieID"}
                label={"Региональное отделение"}
                rules={[{ required: true, message: 'Укажите региональное отделение!' }]}
            >
                <Select disabled={true}>
                    {roptions}
                </Select>
            </Form.Item> */}
                <Form.Item
                    name={"mestoProvedeniyaZasedaniyaID"}
                    label={"Место проведения заседания"}
                    rules={[{ required: true, message: 'Укажите место проведения заседания!' }]}
                >
                    <Select showSearch
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {options}
                    </Select>
                </Form.Item>
                <Form.Item
                    name={"neobkhodimiiKvorum"}
                    label={"Необходимый кворум"}
                    rules={[{ required: true, message: 'Укажите необходимый кворум!' }]}
                >
                    <InputNumber min={0}
                        max={100}
                        formatter={value => `${value}%`}
                        parser={value => Number.parseFloat(value.replace('%', ''))}
                        precision={2}
                        step={0.05}
                        style={{ width: "50%" }} />
                </Form.Item>
            </Form>
        </div>
    );
}